/**
 * ModeSwitch — переключатель «Играю / Создаю».
 *
 * Живёт НАД меню, а не внутри страницы, потому что меняет весь набор
 * пунктов навигации. Приём взят у школы: там так же переключаются
 * направления обучения.
 *
 * Зачем. Сейчас игрок и автор игр видят одно меню, где половина пунктов
 * лишняя каждому. У автора 400+ черновиков и ни одного места, где ими
 * управлять; игроку не нужны «Мои игры» и «Студия».
 */
import React from "react";
import { MODES } from "../../app/nav";
import CabIcon from "./CabIcon";

export default function ModeSwitch({ mode, onChange, collapsed = false }) {
  return (
    <div
      className={`rb-mode ${collapsed ? "is-collapsed" : ""}`}
      role="tablist"
      aria-label="Режим работы"
    >
      {MODES.map((m) => {
        const active = m.id === mode;
        return (
          <button
            key={m.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`rb-mode__btn ${active ? "is-active" : ""}`}
            onClick={() => onChange(m.id)}
            title={m.label}
          >
            <CabIcon name={m.icon} size={16} />
            {!collapsed && <span>{m.label}</span>}
          </button>
        );
      })}
    </div>
  );
}
